/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Selection(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M152,40a7.99977,7.99977,0,0,1-8,8H112a8,8,0,0,1,0-16h32A7.99977,7.99977,0,0,1,152,40Zm-8,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V71.99951a8,8,0,0,0,16,0V48A16.01833,16.01833,0,0,0,208,32Zm8,71.99951a7.99977,7.99977,0,0,0-8,8v32a8,8,0,0,0,16,0v-32A7.99977,7.99977,0,0,0,216,103.99951Zm0,72a7.99977,7.99977,0,0,0-8,8V208H184a8,8,0,0,0,0,16h24a16.01833,16.01833,0,0,0,16-16V183.99951A7.99977,7.99977,0,0,0,216,175.99951Zm-176-24a7.99977,7.99977,0,0,0,8-8v-32a8,8,0,1,0-16,0v32A7.99977,7.99977,0,0,0,40,151.99951ZM72,208H48V183.99951a8,8,0,0,0-16,0V208a16.01833,16.01833,0,0,0,16,16H72a8,8,0,0,0,0-16ZM72,32H48A16.01833,16.01833,0,0,0,32,48V71.99951a8,8,0,0,0,16,0V48H72a8,8,0,0,0,0-16Z" />
    </Svg>
  );
}

export default Selection;
